import { JOURNEY_STEPS } from './config';
export const initialProgress = () => ({ step: 'welcome', articleId: null, paused: false, features: {}, reviewed: false, task: 'reading', completedTasks: {}, cardId: null, deckId: null });
export const progressKey = (userId) => `reedle-onboarding-v2:${userId}`;
export function loadProgress(userId) {
  const value = localStorage.getItem(progressKey(userId));
  if (!value) return initialProgress();
  const state = JSON.parse(value);
  if (!['welcome', 'complete', ...Object.keys(JOURNEY_STEPS)].includes(state.step)
    || typeof state.paused !== 'boolean' || typeof state.reviewed !== 'boolean'
    || !state.features || typeof state.features !== 'object') throw new Error('Invalid onboarding v2 progress');
  return state;
}
export function advanceProgress(state, event) {
  if (state.paused) return state;
  const step = JOURNEY_STEPS[state.step];
  const savesExistingCard = state.step === 'cards-ask' && event.type === 'card-created';
  if (!step || (!savesExistingCard && event.type !== step.event) || !event.articleId) return state;
  if (state.step !== 'open' && event.articleId !== state.articleId) return state;
  if (event.type === 'card-created' && (!event.cardId || !event.deckId)) return state;
  if (state.step === 'cards-review' && event.cardId !== state.cardId) return state;
  const nextStep = savesExistingCard ? 'cards-review' : state.step === 'open' && event.readAlreadyDone ? 'highlight' : step.next;
  return { ...state, articleId: event.articleId, step: nextStep,
    ...(event.type === 'card-created' ? { cardId: event.cardId, deckId: event.deckId } : {}),
    ...(nextStep === 'complete' && state.task === 'cards' ? { reviewed: true } : {}),
    ...(nextStep === 'complete' ? { completedTasks: { ...state.completedTasks, [state.task || 'reading']: true } } : {}),
  };
}
